import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Input,
  FormGroup,
  Badge,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { Triangle } from "react-loader-spinner";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import StockSummaryServices from "../../Services/QRCodeServices/StockSummaryServices/StockSummaryServices";

function StockSummary() {
  const [stockItems, setStockItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const customStyles = {
    headCells: {
      style: {
        fontSize: "0.92rem",
        fontWeight: 610,
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: "Menu Item Name",
      selector: (row) => row.menuItemName,
      sortable: true,
    },
    {
      name: "Purchase Count",
      selector: (row) => row.purchaseCount,
      sortable: true,
      right: true,
    },
    {
      name: "Sales Count",
      selector: (row) => row.menuOrderDetailsCount,
      sortable: true,
      right: true,
    },
    {
      name: "Remaining Quantity",
      selector: (row) => row.remainingQty,
      sortable: true,
      right: true,
    },
    {
      name: "Stock Status",
      selector: (row) => (
        <Badge color={row.isStockLow ? "danger" : "success"}>
          {row.isStockLow ? "Low Stock" : "In Stock"}
        </Badge>
      ),
      sortable: true,
      center: true,
    }
  ];

  async function fetchStockSummary() {
    try {
      setLoading(true);
      const fetchedItems = await StockSummaryServices.getList(); // Hypothetical service call
      setStockItems(fetchedItems);
      setFilteredItems(fetchedItems);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching stock summary:", err);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchStockSummary();
  }, []);

  useEffect(() => {
    let filtered = stockItems;

    if (searchTerm) {
      const lowerCaseSearchTerm = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        item.menuItemName?.toLowerCase().includes(lowerCaseSearchTerm)
      );
    }

    setFilteredItems(filtered);
  }, [searchTerm, stockItems]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Stock Summary Report" pageTitle="Stock Summary" />
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <div className="d-flex flex-wrap gap-2 mt-3">
                    <FormGroup className="col-lg-3">
                      <Input
                        type="text"
                        placeholder="Search by Menu Item Name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </FormGroup>
                  </div>
                </CardHeader>
                <CardBody>
                  <DataTable
                    columns={columns}
                    data={filteredItems}
                    customStyles={customStyles}
                    responsive
                    striped
                    highlightOnHover
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    progressPending={loading}
                    progressComponent={
                      <div className="my-3">
                        <Triangle
                          visible={true}
                          height="80"
                          width="80"
                          color="#5B71B9"
                          ariaLabel="triangle-loading"
                        />
                        <h5 className="mt-1">Loading...</h5>
                      </div>
                    }
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default StockSummary;